/* Bonfi site-wide motion (companion to bonfi-motion.css):
   scroll progress, cart-drawer free-shipping fill, Ken Burns in-view flag,
   magnetic buttons. Everything is skipped under prefers-reduced-motion. */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ------------------------------------------------------------
     2. Scroll progress hairline
     ------------------------------------------------------------ */
  function initProgress() {
    if (document.querySelector('.bonfi-progress')) return;
    var bar = document.createElement('div');
    bar.className = 'bonfi-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);

    var raf = null;
    function update() {
      raf = null;
      var doc = document.documentElement;
      var max = doc.scrollHeight - window.innerHeight;
      var p = max > 0 ? Math.min(1, Math.max(0, (window.scrollY || doc.scrollTop) / max)) : 0;
      bar.style.setProperty('--bonfi-progress', p.toFixed(4));
    }
    window.addEventListener('scroll', function () {
      if (!raf) raf = window.requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ------------------------------------------------------------
     5. Cart drawer free-shipping bar: fill from 0 on open
     ------------------------------------------------------------ */
  function targetFor(bar) {
    var v = parseFloat(bar.style.getPropertyValue('--progress-width'));
    if (isNaN(v)) v = parseFloat(bar.getAttribute('value'));
    return isNaN(v) ? null : Math.max(0, Math.min(100, v));
  }

  function animateBar(bar, from, to) {
    if (bar._bonfiRaf) window.cancelAnimationFrame(bar._bonfiRaf);
    var start = null;
    var duration = 1000;
    function frame(ts) {
      if (start === null) start = ts;
      var t = Math.min(1, (ts - start) / duration);
      var eased = 1 - Math.pow(1 - t, 3);
      var v = from + (to - from) * eased;
      bar.value = v;
      bar.style.setProperty('--progress-width', v.toFixed(2) + '%');
      if (t < 1) bar._bonfiRaf = window.requestAnimationFrame(frame);
      else { bar._bonfiRaf = null; bar.value = to; bar.style.setProperty('--progress-width', to + '%'); }
    }
    bar._bonfiRaf = window.requestAnimationFrame(function () {
      bar._bonfiRaf = window.requestAnimationFrame(frame);
    });
  }

  // On drawer open: fill from 0 to the current value. The theme rewrites the
  // value (attribute + --progress-width) after the cart re-renders, so also
  // ease from the current fill to the new one whenever that happens.
  function fillProgress() {
    document.querySelectorAll('.cart-drawer .cart-message__progress').forEach(function (bar) {
      var to = targetFor(bar);
      if (to === null) return;
      bar._bonfiShown = to;
      animateBar(bar, 0, to);
      if (bar._bonfiWatched || !('MutationObserver' in window)) return;
      bar._bonfiWatched = true;
      new MutationObserver(function () {
        if (bar._bonfiRaf) return; // our own writes
        var next = targetFor(bar);
        if (next === null || next === bar._bonfiShown) return;
        var from = bar._bonfiShown || 0;
        bar._bonfiShown = next;
        animateBar(bar, from, next);
      }).observe(bar, { attributes: true, attributeFilter: ['value', 'style'] });
    });
  }

  function watchDrawer() {
    if (!('MutationObserver' in window)) return;
    var wasOpen = document.body.classList.contains('js-drawer-open-cart');
    new MutationObserver(function () {
      var open = document.body.classList.contains('js-drawer-open-cart');
      if (open && !wasOpen) fillProgress();
      wasOpen = open;
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  /* ------------------------------------------------------------
     6. Ken Burns settle: flag image wrappers as they enter view
     ------------------------------------------------------------ */
  var KB_SELECTOR = '.mosaic__item, .look__image, .image-with-text__image, .overlapping-images__image, .promotion-row__image';

  function initKenBurns(root) {
    root = root || document;
    var els = Array.from(root.querySelectorAll(KB_SELECTOR));
    if (root.matches && root.matches(KB_SELECTOR)) els.unshift(root);
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('bonfi-inview');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.25 });
    els.forEach(function (el) {
      if (el.dataset.bonfiKb || !el.querySelector('img')) return;
      el.dataset.bonfiKb = 'true';
      el.classList.add('bonfi-kb');
      io.observe(el);
    });
  }

  /* ------------------------------------------------------------
     7. Magnetic buttons (fine pointers only)
     ------------------------------------------------------------ */
  var MAGNET_SELECTOR = '.main-content a.btn:not(.btn--text), .main-content button.btn:not(.btn--text), .product__submit__add';
  var MAGNET_MAX = 7;

  function initMagnet(btn) {
    if (btn.dataset.bonfiMagnet) return;
    btn.dataset.bonfiMagnet = 'true';
    btn.classList.add('bonfi-magnet');
    var raf = null;
    var last = null;

    function apply() {
      raf = null;
      if (!last) return;
      var r = btn.getBoundingClientRect();
      if (!r.width || !r.height) return;
      var dx = (last.x - (r.left + r.width / 2)) / (r.width / 2);
      var dy = (last.y - (r.top + r.height / 2)) / (r.height / 2);
      var mx = Math.max(-1, Math.min(1, dx)) * MAGNET_MAX;
      var my = Math.max(-1, Math.min(1, dy)) * MAGNET_MAX * 0.6;
      btn.style.transform = 'translate(' + mx.toFixed(1) + 'px, ' + my.toFixed(1) + 'px)';
    }

    btn.addEventListener('pointerenter', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      btn.classList.remove('is-releasing');
    });
    btn.addEventListener('pointermove', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      last = { x: e.clientX, y: e.clientY };
      if (!raf) raf = window.requestAnimationFrame(apply);
    });
    btn.addEventListener('pointerleave', function () {
      last = null;
      btn.classList.add('is-releasing');
      btn.style.transform = '';
    });
  }

  function initMagnets(root) {
    if (!finePointer) return;
    root = root || document;
    if (root.matches && root.matches(MAGNET_SELECTOR)) initMagnet(root);
    root.querySelectorAll(MAGNET_SELECTOR).forEach(initMagnet);
  }

  /* ------------------------------------------------------------
     boot
     ------------------------------------------------------------ */
  function init() {
    initProgress();
    watchDrawer();
    initKenBurns();
    initMagnets(document);

    if ('MutationObserver' in window) {
      new MutationObserver(function (records) {
        records.forEach(function (record) {
          record.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            initKenBurns(node);
            initMagnets(node);
          });
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', function (event) {
      initKenBurns(event.target);
      initMagnets(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
